import React from "react";
const Unauthorized = () => {
  return (
    <div className="flex flex-col items-center text-center justify-center h-[80vh]">
      <h1 class="text-3xl font-bold text-gray-800 mb-4">Unauthorized</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default Unauthorized;
